'use strict';

import { ESignInProvider } from "app/view/react_components/dialogs/signIn/components/SignInButtons/types";
import { insertLightAnalytics } from "./util/segment-insert-light";

async function onStart() {
    try {
        const {
            gaEnabled,
            acceptLanguage,
            region,
            country,
            city,
            landingPage,
            refferal,
            created,
            utmLanding = {},
            demo,
            demoBase,
        } = window.startOptions;
        await import(/* webpackChunkName: "start_index" */ './start_index.js');
        App.appId = window.Settings.appId;
        App.controller = new App.Views.StartupController({
            gaEnabled: window.Settings.gaEnabled,
            acceptLanguage,
            region,
            country,
            city,
            landingPage,
            refferal,
            demo,
            demoBase,
        });
        App.utmLanding = utmLanding;
        await import(/* webpackChunkName: "startup" */ './startup.js');
        if (created) {
            App.controller.trackEvent('Board', 'Created from Drive');
            App.vent.trigger(App.vent['stat:dashboardCreatedFromDrive']);
        }
    } catch (err) {
        return console.log(err);
    }
}

const landingUrls = [
    '/dashboard/google-workspace-project-management',
    '/dashboard/google-workspace-project-management-v2',
    '/dashboard/taskmanager',
    '/dashboard/ganttchart',
    '/dashboard/brazil',
    '/dashboard/tm',
];
const landingUrlsSlashes = landingUrls.reduce((urls, url) => {
    urls.push(url + '/');
    return urls;
}, landingUrls);
const isLanding = landingUrlsSlashes.includes(location.pathname);

jQuery(document).ready(async () => {
    if (
        localStorage.getItem('RememberMe') ||
        isLanding ||
        window.startOptions.utmLanding && window.startOptions.utmLanding.text ||
        window.startOptions.demo
    ) {
        onStart();
    } else {
        function setLoading() {
            const signin = document.querySelector('.signin');
            signin.classList.add('signin--loading');
        }
        function removeLoading() {
            const signin = document.querySelector('.signin');
            signin.classList.remove('signin--loading');
        }
        const googleButton = document.querySelector('.signin__button--google');
        googleButton.addEventListener('click', async () => {
            setLoading();
            await onStart().catch(removeLoading);
            App.controller.signIn.onSignIn(ESignInProvider.GOOGLE);
        });
        const msButton = document.querySelector('.signin__button--ms');
        msButton.addEventListener('click', async () => {
            setLoading();
            await onStart().catch(removeLoading);
            App.controller.signIn.onSignIn(ESignInProvider.MICROSOFT);
        });
        const demoButton = document.querySelector('.signin__demo');
        demoButton.addEventListener('click', async () => {
            setLoading();
            await onStart().catch(removeLoading);
            App.controller.signIn.onTryDemo();
        });
        const lsCookiesData = localStorage.getItem('COOKIE_DIALOG_LOCALSTORAGE');
        const cookiesData = lsCookiesData ? JSON.parse(lsCookiesData) : {
            isShow: true,
            isSettingsOpened: false,
            isPerformanceAllowed: true,
        };
        let newPerformanceAllowedValue = cookiesData.newPerformanceAllowedValue !== undefined ? cookiesData.newPerformanceAllowedValue : cookiesData.isPerformanceAllowed;
        let isInsertPerformance;
        if (newPerformanceAllowedValue) {
            isInsertPerformance = true;
            await insertLightAnalytics();
            window.analytics.track('User : Sign in button showed', { category: 'User' });
        }
        if (cookiesData.isShow) {
            const cookieEl = document.querySelector('.cookie');
            cookieEl.classList.add('cookie--shown');
            const settings = document.querySelector('.cookie__settings');
            settings.addEventListener('click', () => {
                cookieEl.classList.add('cookie--settings');
            });
            const back = document.querySelector('.cookie__back');
            back.addEventListener('click', () => {
                cookieEl.classList.remove('cookie--settings');
            });
            const performance = document.querySelector('.cookie__performance');
            const input = performance.querySelector('.kui-switch__input');
            performance.addEventListener('change', () => {
                newPerformanceAllowedValue = !newPerformanceAllowedValue;
                if (!newPerformanceAllowedValue) {
                    input.removeAttribute('checked');
                } else {
                    input.setAttribute('checked', 'checked');
                }
                performance.ariaChecked = newPerformanceAllowedValue;
            });
            const agree = document.querySelector('.cookie__agree');
            agree.addEventListener('click', async () => {
                localStorage.setItem('COOKIE_DIALOG_LOCALSTORAGE', JSON.stringify({
                    ...cookiesData,
                    isShow: false,
                    newPerformanceAllowedValue,
                }));
                cookieEl.classList.remove('cookie--shown');
                if (newPerformanceAllowedValue !== cookiesData.isPerformanceAllowed) {
                    if (isInsertPerformance) {
                        const cookies = [
                            '.customer.io',
                            '_cio',
                            '_cioid',
                            '_cioanonid',
                            'cio_u_id',
                        ];
                        function setCookie(name, value, days, domain) {
                            let expires = '';
                            if (days) {
                                let date = new Date();
                                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                                expires = '; expires=' + date.toGMTString();
                            }
                            document.cookie = name + '=' + value + expires + (domain ? ';domain=' + domain : '') + '; path=/';
                        };
                        cookies.forEach(name => setCookie(name, null, -1, '.' + location.hostname));
                    }
                    location.reload();
                }
                if (cookiesData.isPerformanceAllowed) {
                    window.analytics.track('User : Cookies accepted', { category: 'User' });
                }
            });
        }
    }
});
